export default {
    "sword": {
        "name": "Longsword",
        "icon": require("@frog/source/assets/images/hero-tactics/skills/fe/shields/sword.png").default,
    },
    "dagger": {
        "name": "Daggers",
        "icon": require("@frog/source/assets/images/hero-tactics/skills/fe/shields/sword.png").default,
    },
    "hammer": {
        "name": "Warhammer",
        "icon": require("@frog/source/assets/images/hero-tactics/skills/fe/shields/axe.png").default,
    },
    "gun": {
        "name": "Gun",
        "icon": require("@frog/source/assets/images/hero-tactics/skills/fe/shields/axe.png").default,
    },
    "spear": {
        "name": "Spear",
        "icon": require("@frog/source/assets/images/hero-tactics/skills/fe/shields/lance.png").default,
    },
    "bow": {
        "name": "Shortbow",
        "icon": require("@frog/source/assets/images/hero-tactics/skills/fe/shields/bow.png").default,
    },
    "lightning-fist": {
        "name": "Lightning Fist",
        "icon": require("@frog/source/assets/images/hero-tactics/skills/fe/shields/lightning-magic.png").default,
    },
    "water-fist": {
        "name": "Water Fist",
        "icon": require("@frog/source/assets/images/hero-tactics/skills/fe/shields/wind-magic.png").default,
    },
    "ground-fist": {
        "name": "Earth Fist",
        "icon": require("@frog/source/assets/images/hero-tactics/skills/fe/shields/dark-magic.png").default,
    },
    "lightning-magic": {
        "name": "Anima Lightning",
        "icon": require("@frog/source/assets/images/hero-tactics/skills/fe/shields/lightning-magic.png").default,
    },
    "water-magic": {
        "name": "Holy Water",
        "icon": require("@frog/source/assets/images/hero-tactics/skills/fe/shields/wind-magic.png").default,
    },
    "ground-magic": {
        "name": "Eldritch Earth",
        "icon": require("@frog/source/assets/images/hero-tactics/skills/fe/shields/dark-magic.png").default,
    },



    // LIGHTNING //
    "throwing-knives": {
        "name": "Throwing Knives",
        // "icon": require("@frog/source/assets/images/prototype-tactics/game-icons/thrown-daggers.svg").default,
        "icon": require("@frog/source/assets/images/hero-tactics/skills/fe/shields/sword.png").default,
        "description": "Kthunk! Lodge a knife in their back."
    },
    "twisted-dagger": {
        "name": "Twisted Dagger",
        // "icon": require("@frog/source/assets/images/prototype-tactics/game-icons/knife-thrust.svg").default,
        "icon": require("@frog/source/assets/images/hero-tactics/skills/fe/shields/sword.png").default,
        "description": "With a twist of the dagger, *ignores all armor.*"
    },
    "ninja-stars": {
        "name": "Ninja Stars",
        // "icon": require("@frog/source/assets/images/prototype-tactics/game-icons/ninja-star.svg").default,
        "icon": require("@frog/source/assets/images/hero-tactics/skills/fe/shields/sword.png").default,
        "description": "Specially designed blades that *ignores elemental effects.*",
    },
    "blink": {
        "name": "Blink",
        // "icon": require("@frog/source/assets/images/prototype-tactics/game-icons/teleport.svg").default,
        "icon": require("@frog/source/assets/images/hero-tactics/skills/fe/shields/bag.png").default,
        "description": "Teleports to any tile within 2 to 4 tiles."
    },
    "swap": {
        "name": "Swap",
        // "icon": require("@frog/source/assets/images/prototype-tactics/game-icons/back-forth.svg").default,
        "icon": require("@frog/source/assets/images/hero-tactics/skills/fe/shields/bag.png").default,
        "description": "Trades positions with an adjacent unit.",
    },
    "hook": {
        "name": "Chainhook",
        // "icon": require("@frog/source/assets/images/prototype-tactics/game-icons/meat-hook.svg").default,
        "icon": require("@frog/source/assets/images/hero-tactics/skills/fe/shields/bag.png").default,
        "description": "Pulls a unit backwards 1 tile."
    },
    // "dodge": {
    //     "name": "Dodge",
    //     "icon": require("@frog/source/assets/images/prototype-tactics/game-icons/dodging.svg").default,
    //     "description": "Dodges the next attack."
    // },
    // "boomerang": {
    //     "name": "Boomerang",
    //     "icon": require("@frog/source/assets/images/prototype-tactics/game-icons/armored-boomerang.svg").default,
    //     "description": "Spins through 2 tiles, then back 2 tiles."
    // },
    // "backstab": {
    //     "name": "Backstab",
    //     "icon": require("@frog/source/assets/images/prototype-tactics/game-icons/armored-boomerang.svg").default,
    //     "description": "Deals extra damage when attacking from behind."
    // },

    // GROUND //

    "smash": {
        "name": "Smash",
        // "icon": require("@frog/source/assets/images/prototype-tactics/game-icons/thor-hammer.svg").default,
        "icon": require("@frog/source/assets/images/hero-tactics/skills/fe/shields/axe.png").default,
        "description": "Bring down your hammer, dealing earth damage."
    },
    "enrage": {
        "name": "Enrage",
        // "icon": require("@frog/source/assets/images/prototype-tactics/game-icons/enrage.svg").default,
        "icon": require("@frog/source/assets/images/hero-tactics/skills/fe/shields/axe.png").default,
        "description": "Deals extra damage the more you're damaged."
    },
    "vengeance": {
        "name": "Vengeance",
        // "icon": require("@frog/source/assets/images/prototype-tactics/game-icons/pyromaniac.svg").default,
        "icon": require("@frog/source/assets/images/hero-tactics/skills/fe/shields/axe.png").default,
        "description": "Deals extra damage when counter-attacking."
    },
    "critical-strike": {
        "name": "Critical Strike",
        // "icon": require("@frog/source/assets/images/prototype-tactics/game-icons/deadly-strike.svg").default,
        "icon": require("@frog/source/assets/images/hero-tactics/skills/fe/shields/axe.png").default,
        "description": "Deals extra damage every nth attack.",
    },
    "shove": {
        "name": "Shove",
        // "icon": require("@frog/source/assets/images/prototype-tactics/game-icons/push.svg").default,
        "icon": require("@frog/source/assets/images/hero-tactics/skills/fe/shields/bag.png").default,
        "description": "Pushes a unit over 1 tile."
    },
    "charge": {
        "name": "Charge",
        // "icon": require("@frog/source/assets/images/prototype-tactics/game-icons/shield-bash.svg").default,
        "icon": require("@frog/source/assets/images/hero-tactics/skills/fe/shields/bag.png").default,
        "description": "Charges forward until you hit something."
    },

    // WATER //

    "bubbles": {
        "name": "Healing Bubbles",
        // "icon": require("@frog/source/assets/images/prototype-tactics/game-icons/bubbles.svg").default,
        "icon": require("@frog/source/assets/images/hero-tactics/skills/fe/shields/staff.png").default,
        "description": "Restore health."
    },
    "waterfall": {
        "name": "Waterfall",
        // "icon": require("@frog/source/assets/images/prototype-tactics/game-icons/waterfall.svg").default,
        "icon": require("@frog/source/assets/images/hero-tactics/skills/fe/shields/light-magic.png").default,
        "description": "Deal big water damage. Then heal big damage."
    },
    "stream": {
        "name": "Life Stream",
        // "icon": require("@frog/source/assets/images/prototype-tactics/game-icons/splashy-stream.svg").default,
        "icon": require("@frog/source/assets/images/hero-tactics/skills/fe/shields/light-magic.png").default,
        "description": "Deal water damage. Heal yourself."
    },
    "wave": {
        "name": "Crashing Wave",
        // "icon": require("@frog/source/assets/images/prototype-tactics/game-icons/wave-crest.svg").default,
        "icon": require("@frog/source/assets/images/hero-tactics/skills/fe/shields/light-magic.png").default,
        "description": "Deal water damage. Heal yourself."
    },
    "splash": {
        "name": "Splash",
        // "icon": require("@frog/source/assets/images/prototype-tactics/game-icons/water-splash.svg").default,
        "icon": require("@frog/source/assets/images/hero-tactics/skills/fe/shields/light-magic.png").default,
        "description": "Deal water damage, splashing adjacent tiles with more water damage."
    },
}
